import { render } from "./MaterialAsinChange.vue?vue&type=template&id=516ca89b"
import script from "./MaterialAsinChange.vue?vue&type=script&lang=js"
export * from "./MaterialAsinChange.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__